
const NotFound: React.FunctionComponent = () => {
    return (
        <h1>Page was not found</h1>
    );
}

export default NotFound;